import React from 'react';

const Tab = (props) => {
    const { tabData, isActive, onTabSelectHandler, idx } = props;

    return (
        <div className="grid-col-6 gi-tabs__item">
            <button className={isActive ? 'active' : ''}
                id={`tab-${idx}`}
                role="tab"
                onClick={onTabSelectHandler}
                data-automation-id={`tab-${tabData.applicationYear}`}
                aria-selected={isActive ? 'true' : 'false'}
                aria-controls={`tabpanel_${tabData.applicationYear}`}>
                {tabData.applicationYear}
            </button>
        </div>
    );
};

export default Tab;